import { adminHttpClient } from '../../../commons/adminHttpClient'

const canInitiateRenewal = (): Promise<boolean> =>
  adminHttpClient.get('Benefit/BenefitRenewal/Perks/CanInitiateRenewal')

export default canInitiateRenewal
